<template>
  <div class="userInformation">
    <div class="col1">
      <van-image class="avatarImg" :src="avatar"></van-image>
    </div>
    <div class="col2" @click="onCopy(userData.CustomerNumber)">
      <div class="row2">
        <span class="name">{{ userData.CompanyName }}</span>
      </div>
      <div class="row2">
        <span class="label">{{ $t.auth.customerNumber }}</span
        ><span class="txt"
          ><div class="copyTxt">{{ userData.CustomerNumber }}</div>
          <van-image class="copyImg" :src="copy"></van-image>
        </span>
      </div>
    </div>
    <div class="col3" @click="gotoEdit">
      <van-image class="iconImg" :src="edit"></van-image>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image } from "vant";
Vue.use(Image);
export default {
  name: "UserInformation",
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      avatar: require("@/assets/img/userManage/img_logo@2x.png"),
      copy: require("@/assets/img/userManage/copy.png"),
      edit: require("@/assets/img/home/edit.png"),
    };
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    gotoEdit() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "user/editInformation",
        name: "EditInformation",
        query: [
          {
            name: "IsNew",
            value: false,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
// 是设计图是三杯图
.userInformation {
  background: #ffffff;
  margin: 15px 10px 10px 10px;
  padding: 5% 0;
  border-radius: 20px;
  color: #0e78a6;
  border: 1px solid #ebedf0;
  box-shadow: 0px 2px 10px 2px rgb(0 0 0 / 10%);
}
.col1 {
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  width: 30%;
  .avatarImg {
    width: 50%;
    height: 50%;
  }
}
.col2 {
  margin-top: 5px;
  vertical-align: middle;
  display: inline-block;
  width: 60%;
  font-size: 12px;
  .row2 {
    line-height: 20px;
    margin-bottom: 5px;
    overflow: hidden;
    .name {
      height: 18px;
      color: #333;
      font-size: 16px;
      font-weight: bold;
    }
    .label {
      height: 18px;
      display: inline-block;
      color: #999;
      vertical-align: middle;
    }
    .txt {
      height: 18px;
      width: 70%;
      display: inline-block;
      margin-left: 10px;
      color: #999;
      font-weight: normal;
      vertical-align: middle;
      white-space: nowrap;
      .copyTxt {
        display: inline-block;
        vertical-align: middle;
      }
      .copyImg {
        width: 15px;
        height: 15px;
        margin-left: 3px;
        object-fit: contain;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
.col3 {
  text-align: center;
  vertical-align: top;
  display: inline-block;
  width: 10%;
  .iconImg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 15px;
    vertical-align: middle;
  }
}
</style>
